import React from 'react'
import { lit } from 'src/utils'
import { CloseIcon } from '../icons/CloseIcon'

// @NB only imageMaxHeight applies to Cards with the `metaPosition: Hero` option applied
export interface FilterCardProps {
    children?: React.ReactNode
    className?: string
    editUrl?: string

    /**
     * Make the image circular (thumb and people cards)
     */
    isEllipse?: boolean

    orientation?: 'vertical' | 'horizontal'

    layout?: 'news' | 'general' | 'thumb' | 'people' | 'artwork' | 'filter'

    size?: 'small' | 'medium' | 'large'

    /**
     * Appears above all other text. Regular font. All caps.
     */
    overline?: string

    showEditIcon?: boolean

    /**
     * Callback function to handle the filter card closing
     */
    onClose?: () => void

    showRemoveIcon?: boolean

    linkComponent?: any
}

export function FilterCard({
    children,
    className = 'FilterCard',
    orientation = 'vertical',
    layout = 'thumb',
    showEditIcon = false,
    onClose,
    showRemoveIcon,
    linkComponent,
}: FilterCardProps) {
    if (showRemoveIcon === undefined) {
        showRemoveIcon = layout === 'filter'
    }

    const wrapperClassNames = lit`
        ${className} relative lg:max-w-full overflow-x-hidden flex
        items-center
        ${
            layout === 'filter'
                ? 'w-full p-4 border border-neutral-200 justify-between'
                : 'justify-center'
        }
    `

    return (
        <div className={wrapperClassNames}>
            <div className={lit`${orientation === 'vertical' && 'mt-6'}`}>
                {children}
            </div>
            <div className="min-w-fit">
                {showEditIcon && <>{linkComponent}</>}
                {showRemoveIcon && (
                    <button type="button" onClick={onClose}>
                        {' '}
                        <CloseIcon />{' '}
                    </button>
                )}
            </div>
        </div>
    )
}
